import React from 'react';
import Validator from 'validatorjs';
import { Col, Form, Row } from 'react-bootstrap';

import { FormControl } from '../../../../../facturotopia';
import ComplementoPagosRules from '../../../support/rules/ComplementoPagosRules';
import MonedaPOptions from '../../../support/catalogs/complementos/pagos/MonedaPOptions';
import FormaDePagoPOptions from '../../../support/catalogs/complementos/pagos/FormaDePagoPOptions';

const PagoForm = (props) => {
  const { data } = props;

  const rules = ComplementoPagosRules(data);

  const handleOnChange = (value) => {
    const newData = {
      ...props.data,
      ...value,
    }

    const validator = validate(newData);

    props.onChange(newData, validator.passes());
  };

  const validate = (data) => {
    const rules = ComplementoPagosRules(data);

    return new Validator(data, rules);
  };

  return (
    <div>
      <div className="py-2">
        <strong className="text-upper text-muted">Información del pago</strong>
      </div>

      <Form autoComplete="off" className="mt-2" data-testid="PagoForm">
        <Row>
          <Col xs="12" sm="6" md={ 4 }>
            <FormControl type="date-picker"
              label="Fecha de pago"
              name="FechaPago"
              maxLength="10"
              rules={ rules.FechaPago }
              value={ data.FechaPago }
              onChange={ handleOnChange }
            />
          </Col>

          <Col xs="12" sm="6" md={ 4 }>
            <FormControl type="text"
              label="Hora de pago"
              name="HoraPago"
              placeholder="Ej. 12:00"
              help="Formato horas:minutos, 24 horas"
              maxLength="5"
              rules={ rules.HoraPago }
              value={ data.HoraPago }
              onChange={ handleOnChange }
            />
          </Col>

          <Col xs="12" sm="6" md={ 4 }>
            <FormControl type="select"
              label="Forma de pago"
              name="FormaDePagoP"
              placeholder=""
              help=""
              rules={ rules.FormaDePagoP }
              value={ data.FormaDePagoP }
              options={ FormaDePagoPOptions }
              onChange={ handleOnChange }
            />
          </Col>

          <Col xs="12" sm="6" md={ 4 }>
            <FormControl type="select"
              label="Moneda"
              name="MonedaP"
              placeholder=""
              help=""
              rules={ rules.MonedaP }
              value={ data.MonedaP }
              options={ MonedaPOptions }
              onChange={ handleOnChange }
            />
          </Col>

          <Col xs="12" sm="6" md={ 4 }>
            <FormControl type="text"
              label="Tipo de cambio"
              name="TipoCambioP"
              placeholder=""
              help=""
              rules={ rules.TipoCambioP }
              value={ data.TipoCambioP }
              onChange={ handleOnChange }
            />
          </Col>

          <Col xs="12" sm="6" md={ 4 }>
            <FormControl type="number"
              label="Monto"
              name="Monto"
              placeholder=""
              help=""
              rules={ rules.Monto }
              value={ data.Monto }
              onChange={ handleOnChange }
            />
          </Col>

          <Col xs="12" sm="6" md={ 4 }>
            <FormControl type="number"
              label="Número de operación"
              name="NumOperacion"
              placeholder=""
              help=""
              rules={ rules.NumOperacion }
              value={ data.NumOperacion }
              onChange={ handleOnChange }
            />
          </Col>

          <Col xs="12" sm="6" md={ 4 }>
            <FormControl type="text"
              label="Cuenta Ordenante"
              name="CtaOrdenante"
              placeholder=""
              help=""
              rules={ rules.CtaOrdenante }
              value={ data.CtaOrdenante }
              onChange={ handleOnChange }
            />
          </Col>

          <Col xs="12" sm="6" md={ 4 }>
            <FormControl type="text"
              label="Cuenta Beneficiario"
              name="CtaBeneficiario"
              placeholder=""
              help=""
              rules={ rules.CtaBeneficiario }
              value={ data.CtaBeneficiario }
              onChange={ handleOnChange }
            />
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default PagoForm;
